import { useEffect, useRef, useState } from 'react';
import Services from '../../Services/services.js';
import { ToastThemes } from '../../Toasts/ToastOptions/toastOptions';
import useToast from '../../Toasts/useToast';

function CalendarAppointment({ clientExpertRelation, isExpert, hour }) {
	const ref = useRef(true);

	const [user, setUser] = useState();

	const [cabinet, setCabinet] = useState();

	const enqueueToast = useToast();

	async function FetchUser() {
		try {
			if (isExpert) {
				const userData = await Services.userService.userByID(
					clientExpertRelation?.client?.userId
				);

				setUser(userData);
			} else {
				const userData = await Services.userService.userByID(
					clientExpertRelation?.expert?.userId
				);

				setUser(userData);
			}
		} catch (error) {
			console.error(error);
		}
	}

	async function FetchCabinet() {
		const cabinetData = await Services.cabinetService.cabinetByID(
			clientExpertRelation?.expert?.cabinetId,
			true
		);

		if (cabinetData.length > 0) setCabinet(cabinetData[0]);
	}

	async function CopyToClipboard(value) {
		navigator.clipboard.writeText(value);

		enqueueToast(value, {
			theme: ToastThemes.toastThemes.CONFIRM_SUCCESS,
			header: 'Press-papier',
			duration: 3000,
		});
	}

	useEffect(() => {
		if (ref.current) {
			ref.current = false;
			FetchUser();
			FetchCabinet();
		}
	});

	return (
		<div className="planning-appointment-content">
			<div className="appointment-content-data">
				<span className="data-name">
					RDV avec{' '}
					{isExpert
						? clientExpertRelation?.client?.firstName
						: clientExpertRelation?.expert?.firstName}{' '}
					{isExpert
						? clientExpertRelation?.client?.lastName
						: clientExpertRelation?.expert?.lastName}
				</span>
				<span className="data-address">{cabinet?.address}</span>
				<span className="data-city">
					{cabinet?.location?.zipCode} {cabinet?.location?.city}
				</span>
				<span className="data-hour">{hour}</span>
			</div>
			<div className="appointment-content-communications">
				<button
					type="button"
					className="communication-phone-btn"
					onClick={() => CopyToClipboard(user?.phone)}
				>
					<span>{user?.phone}</span>
				</button>
				<button
					type="button"
					className="communication-email-btn"
					onClick={() => CopyToClipboard(user?.email)}
				>
					<span>{user?.email}</span>
				</button>
			</div>
		</div>
	);
}

export default CalendarAppointment;
